import { useMatchRoute } from '@tanstack/react-router'

import { TopbarNavigationProps } from '../components/topbar-navigation/TopbarNavigation'
import { useSavingsConverter } from './useSavingsConverter'
import { useSpkFarmApy } from './useSpkFarmApy'
import { useBlockedPages } from '@/features/compliance/logic/useBlockedPages'
import { InternalLink } from '@/routing/types'

export function useNavigationInfo(): TopbarNavigationProps {
  const blockedPages = useBlockedPages()
  const savingsConverter = useSavingsConverter()
  const spkFarmApy = useSpkFarmApy()
  const matchRoute = useMatchRoute()

  const sparkLendSubLinks: TopbarNavigationProps['sparkLendSubLinks'] = [
    {
      link: InternalLink({ to: '/borrow' }),
      label: 'Borrow stablecoins',
    },
    {
      link: InternalLink({ to: '/my-portfolio' }),
      label: 'My portfolio',
    },
    {
      link: InternalLink({ to: '/markets' }),
      label: 'Markets',
    },
  ]

  const spkTokenSubLinks: TopbarNavigationProps['spkTokenSubLinks'] = [
    {
      link: InternalLink({ to: '/spk/staking' }),
      label: 'Staking',
      description: 'Deposit SPK and earn Spark Points',
      standaloneLabel: 'SPK Staking',
    },
    {
      link: InternalLink({ to: '/spk/airdrop' }),
      label: 'Airdrop',
      standaloneLabel: 'SPK Airdrop',
      description: 'Check your eligibility for the SPK Airdrop',
    },
    {
      link: InternalLink({ to: '/spk/farm' }),
      label: 'Farm',
      standaloneLabel: 'SPK Farm',
      description: 'Deposit USDS and earn SPK Rewards',
      apy: spkFarmApy,
    },
    {
      link: InternalLink({ to: '/spk/governance' }),
      label: 'Governance',
      standaloneLabel: 'SPK Governance',
      description: 'Check your voting power, manage delegation, or vote on proposals',
    },
  ]

  const isSparkLendSubLinkActive = sparkLendSubLinks.some(({ link }) => !!matchRoute({ to: link.to, fuzzy: true }))
  const isSparkTokenSubLinkActive = spkTokenSubLinks.some(({ link }) => !!matchRoute({ to: link.to, fuzzy: true }))

  return {
    savingsConverter,
    blockedPages,
    sparkLendSubLinks,
    spkTokenSubLinks,
    isSparkLendSubLinkActive,
    isSparkTokenSubLinkActive,
  }
}
